<template>
  <div class="bg-gray-800 sm:rounded-l-lg sm:rounded-bl-lg py-6 h-full flex flex-col">
    <div class="text-white px-6 h-[40%]">
      <portal-billing-proposal-steps-timeline
        :current-step="currentStep"
        :available-steps="availableSteps"
      />
    </div>
  </div>
</template>
<script>
import PortalBillingProposalStepsTimeline from "./PortalBillingProposalStepsTimeline.vue"

export default {
  name: "PortalBillingProposalSteps",
  components: {
    PortalBillingProposalStepsTimeline,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    availableSteps: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      companyData: window.FinancialCents.company,
    }
  },
}
</script>
